document.addEventListener('DOMContentLoaded', function () {
  const guideOverlays = document.querySelectorAll('.diamond-size-guide-overlay');

  if (guideOverlays.length === 0) return;

  guideOverlays.forEach(overlay => {
    const stone = overlay.querySelector('.diamond-size-guide-stone');
    const buttons = overlay.querySelectorAll('.diamond-size-guide-controls button');

    if (!stone || buttons.length === 0) return;

    // Initialize stone scale based on active button
    const activeButton = overlay.querySelector('.diamond-size-guide-controls button.active');
    if (activeButton) {
      const initialScale = activeButton.getAttribute('data-scale');
      if (initialScale) {
        stone.style.transform = `scale(${initialScale})`;
      }
    }

    buttons.forEach(button => {
      // Prevent clicks on buttons from opening the modal or changing slides
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Remove active class from all buttons
        buttons.forEach(btn => btn.classList.remove('active'));

        // Add active class to clicked button
        this.classList.add('active');

        // Get scale value
        const scaleValue = this.getAttribute('data-scale');

        // Apply transform to the stone
        if (scaleValue) {
          stone.style.transform = `scale(${scaleValue})`;
        }
      });

      // Also prevent mousedown/mouseup events from bubbling up to the modal opener
      button.addEventListener('mousedown', e => e.stopPropagation());
      button.addEventListener('mouseup', e => e.stopPropagation());
      button.addEventListener('touchstart', e => e.stopPropagation(), { passive: true });
      button.addEventListener('touchend', e => e.stopPropagation(), { passive: true });
    });
  });
});
